import { gql } from '@apollo/client';

export const GET_SPECIALTY = gql`
  query getSpecialty {
    specialties {
      derma_type
      id
      specialty
      status
    }
  }
`;

